<template>
  <div style="flex:1; padding:20px">
    <el-row>
  <h2 style="float:left; margin-left:15px">Partners</h2>
<br>
      <el-button style="float:right; margin-right:30px" @click="Create()">Create</el-button>
    </el-row>
    <br />
    <el-card>
      <el-table v-loading="loading" :data="partners" class="border">
        <el-table-column prop="domain" label="domain"></el-table-column>
        <el-table-column prop="name" label="Name"></el-table-column>
        <el-table-column prop="email" label="Email"></el-table-column>
        <el-table-column prop="phone" label="Phone"></el-table-column>
        <el-table-column prop="address" label="Address"></el-table-column>
        <el-table-column label="Actions">
          <template slot-scope="scope">
            <el-button @click="Edit(scope.row._id)">Edit</el-button>
            <el-button type="danger" @click="Delete(scope.row._id)">Delete</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog width="30%" vtitle="Edit Point" :visible.sync="showForm">
      <el-form ref="form" :model="form" :rules="rules" v-loading="formLoading" label-width="100px">
     
        <el-form-item label="Domain" prop="domain">
          <el-input  :disabled="this.editId" v-model="form.domain"></el-input>
        </el-form-item>
        <el-form-item label="Name" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="Phone" prop="phone">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>
             <el-form-item label="Address" prop="address">
          <el-input v-model="form.address"></el-input>
        </el-form-item>
        <el-form-item label="Email" prop="email">
          <el-input v-model="form.email"></el-input>
        </el-form-item>
        
        <el-form-item>
          <el-button v-if="!this.editId" type="primary" @click="CreatePartner()">Create</el-button>
          <el-button v-if="this.editId" type="primary" @click="UpdatePartner()">Update</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "partner",
  data() {
    return {
     
      formLoading: false,
      showForm: false,
      editId: "",
      form: {
        name: "",
        domain: "",
        email: "",
        phone: "",
        address: ""
      },
      rules: {
        domain: [
          { required: true, message: "Please input domain", trigger: "blur" }
        ],
        name: [
          { required: true, message: "Please input surname", trigger: "blur" }
        ],
       
        email: [
          {
            required: true,
            message: "Please input email",
            trigger: "blur"
          }
        ],
      }
    };
  },
  created() {
    this.getPartners();
  },
  computed: {
    ...mapState("partner", ["partners", "loading"])
  },
  methods: {
    ...mapActions("partner", ["createPartner", "updatePartner", "deletePartner"]),
    ...mapActions("partner", ["getPartners"]),
    CreatePartner() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.formLoading = true;
          this.createPartner(this.form)
            .then(() => {
              this.formLoading = false;
              this.showForm = false;
            })
            .finally(() => (this.formLoading = false));
        }
      });
    },
    Delete(id) {
      this.$confirm(
        "This will permanently delete the partner. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() =>
          this.deletePartner(id)
        )
        .catch((e) => {
          this.$message({
            type: "info",
            message: e
          });
        });
    },
    UpdatePartner() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.formLoading = true;
          this.form.id = this.editId;
          this.updatePartner(this.form)
            .then(() => {
              this.formLoading = false;
              this.showForm = false;
            })
            .finally(() => (this.formLoading = false));
        }
      });
    },
    Create() {
      this.editId = undefined;
      this.showForm = true;
    },
    Edit(id) {
      this.editId = id;
      const partner = this.partners.find(x => x._id == id);
      if (partner) {
        this.form.name = partner.name;
        this.form.domain = partner.domain;
        this.form.phone = partner.phone;
        this.form.email = partner.email;
        this.form.address = partner.address;
      }
      this.showForm = true;
    },
    
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped>
.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}
.tree-container {
  flex-basis: 20%;
  border: 1.5px solid #e4e7ed;
  margin-right: 10px;
}
.tabs {
  flex-basis: 80%;
  display: flex;
}
</style>